module.exports = __webpack_public_path__ + "static/media/pizza.906ca9fa.jpeg";